//neige
const NUMBER_OF_SNOWFLAKES_PC = 150;
const NUMBER_OF_SNOWFLAKES_MOBILE = 100;
const MAX_SNOWFLAKE_SIZE_PC = 3;
const MAX_SNOWFLAKE_SIZE_MOBILE = 3;
const MAX_SNOWFLAKE_SPEED_PC = 2;
const MAX_SNOWFLAKE_SPEED_MOBILE = 1;
const SNOWFLAKE_COLOUR = '#ddd';

const snowflakes = [];
const canvas = document.createElement('canvas');
canvas.style.position = 'fixed';
canvas.style.pointerEvents = 'none';
canvas.style.top = '0';
canvas.style.left = '0';
canvas.style.zIndex = '9999'; // Assure que le canvas est au-dessus de tout
canvas.width = window.innerWidth;
canvas.height = window.innerHeight;
document.body.appendChild(canvas);

const ctx = canvas.getContext('2d');

let numberOfSnowflakes = NUMBER_OF_SNOWFLAKES_PC;
let maxSnowflakeSize = MAX_SNOWFLAKE_SIZE_PC;
let maxSnowflakeSpeed = MAX_SNOWFLAKE_SPEED_PC;

// Fonction pour ajuster les paramètres selon la largeur de l'écran
const adjustForScreenSize = () => {
    if (window.innerWidth <= 768) { // Mobile
        numberOfSnowflakes = NUMBER_OF_SNOWFLAKES_MOBILE;
        maxSnowflakeSize = MAX_SNOWFLAKE_SIZE_MOBILE;
        maxSnowflakeSpeed = MAX_SNOWFLAKE_SPEED_MOBILE;
    } else { // Desktop
        numberOfSnowflakes = NUMBER_OF_SNOWFLAKES_PC;
        maxSnowflakeSize = MAX_SNOWFLAKE_SIZE_PC;
        maxSnowflakeSpeed = MAX_SNOWFLAKE_SPEED_PC;
    }
    // Réinitialiser les flocons pour correspondre aux nouvelles dimensions
    snowflakes.length = 0;
    for (let i = 0; i < numberOfSnowflakes; i++) {
        snowflakes.push(createSnowflake());
    }
};

const createSnowflake = () => ({
    x: Math.random() * canvas.width,
    y: Math.random() * canvas.height,
    radius: Math.floor(Math.random() * maxSnowflakeSize) + 1,
    color: SNOWFLAKE_COLOUR,
    speed: Math.random() * maxSnowflakeSpeed + 0.5,
    sway: (Math.random() - 0.5) * 0.5,
});

const drawSnowflake = (snowflake) => {
    ctx.beginPath();
    ctx.arc(snowflake.x, snowflake.y, snowflake.radius, 0, Math.PI * 2);
    ctx.fillStyle = snowflake.color;
    ctx.fill();
    ctx.closePath();
};

const updateSnowflake = (snowflake) => {
    snowflake.y += snowflake.speed;
    snowflake.x += snowflake.sway;
    if (snowflake.y > canvas.height || snowflake.x < 0 || snowflake.x > canvas.width) {
        Object.assign(snowflake, createSnowflake(), { y: 0 });
    }
};

const animate = () => {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    snowflakes.forEach((snowflake) => {
        updateSnowflake(snowflake);
        drawSnowflake(snowflake);
    });
    requestAnimationFrame(animate);
};

window.addEventListener('resize', () => {
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
    adjustForScreenSize();
});

// Initialisation
adjustForScreenSize();
animate();